import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XpoAllowCharactersDirective } from './allow-characters.directive';

const directives = [XpoAllowCharactersDirective];

@NgModule({
  imports: [CommonModule],
  declarations: directives,
  exports: directives,
})
export class XpoAllowCharactersModule {}
